import React, { useState } from 'react';
import {
  ScreenComponentPlugin,
  ScreenComponentProps
} from '../ScreenComponentPlugin';
import { useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';
import { isSafari } from 'react-device-detect';

import CompareChart from '../../../../components/charts/CompareChart';
import { B, P } from '../../../../components/Typography';
import { Octicons } from '@expo/vector-icons';
import IconButton from '../../../../components/IconButton';
import WebViewModal from '../../../modals/WebViewModal';
import Card from '../../../../components/Card';
import elementIDs from '../../../../../elementIDs';

const sampleData = [
  { x: -2, y: 0 },
  { x: -1.8, y: 0.5 },
  { x: -1.6, y: 0.6 },
  { x: -1.4, y: 1 },
  { x: -1.2, y: 2 },
  { x: -1.0, y: 3 },
  { x: -0.8, y: 4 },
  { x: -0.6, y: 6 },
  { x: -0.4, y: 10 },
  { x: -0.2, y: 15 },
  { x: 0, y: 23 },
  { x: 0.2, y: 29 },
  { x: 0.4, y: 33 },
  { x: 0.6, y: 34 },
  { x: 0.8, y: 33 },
  { x: 1, y: 29 },
  { x: 1.2, y: 23 },
  { x: 1.4, y: 15 },
  { x: 1.6, y: 10 },
  { x: 1.8, y: 6 },
  { x: 2, y: 4 },
  { x: 2.2, y: 3 },
  { x: 2.4, y: 1.5 },
  { x: 2.6, y: 0.9 },
  { x: 2.8, y: 0.5 },
  { x: 3, y: 0 }
];

const StyledCard = styled(Card)<{
  isDesktop: boolean;
}>`
  align-self: center;
  ${isSafari ? 'width: 85%' : 'width: 100%'}
  padding: 19px 0 25px 0;
`;
const StyledContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const StyledTitleView = styled.View`
  margin: 0 19px 20px 19px;
`;

const StyledSubTitle = styled(P)`
  font-size: 16px;
  line-height: 18.77px;
  letter-spacing: -0.07px;
  margin-top: 30px;
`;

const StyledTitle = styled(B)`
  font-size: 21px;
  line-height: 24.63px;
  letter-spacing: -0.07px;
`;

const StyledIconButton = styled(IconButton)``;
export interface CompareChartCardProps {
  title?: string;
  hasMoreInfo?: boolean;
  infoTitle?: string;
  infoHtml?: string;
  yAxisLeftLabel?: string;
  xAxisBottomLabel?: string;
}

const CompareChartCard: React.FC<
  ScreenComponentProps<CompareChartCardProps>
> = ({ hasMoreInfo, infoTitle, infoHtml, ...props }) => {
  const window = useWindowDimensions();
  const isDesktop = window.width >= 768;
  const [showModal, setShowModal] = useState<boolean>();
  return (
    <StyledCard isDesktop={isDesktop} testID={elementIDs.resultsCompareID}>
      <StyledTitleView>
        <StyledContainer>
          <StyledTitle color='dark'>Results: Compare</StyledTitle>
          {hasMoreInfo && (
            <StyledIconButton
              onPress={() => setShowModal(true)}
              testID={elementIDs.pluginCompareInfoID}
            >
              <Octicons name='question' size={24} color='#494753' />
            </StyledIconButton>
          )}
        </StyledContainer>
        <StyledSubTitle testID={elementIDs.compareChartTitleID} color='dark'>
          {props.title
            ? props.title
            : 'How do other people respond to Dreem Capsules?'}
        </StyledSubTitle>
      </StyledTitleView>
      <CompareChart
        intervention='Dreem Capsule'
        subject='Sleep'
        study='Sleep duration'
        xAxisValueUnits='HRS'
        data={sampleData}
        position={1.2}
        xAxisMinValueLabel={-2}
        xAxisMaxValueLabel={3}
        yAxisMaxValueLabel={40}
        plugin
        {...props}
      />
      {showModal && (
        <WebViewModal
          contentPadding
          visible={showModal}
          title={infoTitle || ''}
          html={infoHtml || ''}
          onClose={() => setShowModal(false)}
        />
      )}
    </StyledCard>
  );
};

export const CompareChartCardPlugin: ScreenComponentPlugin<CompareChartCardProps> =
  {
    name: 'Compare Chart Card',
    type: 'CompareChartCard',
    categories: ['study-progress'],
    component: CompareChartCard
  };
